"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var theme = require("./theme.scss");
var ReportingRow_1 = require("../reportingRow/ReportingRow");
var classnames = require("classnames");
var lib_1 = require("../../../../lib");
var ReportingList = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingList, _super);
    function ReportingList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onToggleReportingSumOnTop = function () {
            _this.props.toggleReportingSumOnTop();
        };
        _this.renderSumBar = function (scrollTop, scrollLeft, columnsWidth, setFreezeColumn, freezeColumnIndex, onTop) {
            if (onTop === void 0) { onTop = false; }
            var _a = _this.props, sortDirection = _a.sortDirection, onSort = _a.onSort, reportingSumOnTop = _a.reportingSumOnTop, filteredTotal = _a.filteredTotal, groups = _a.groups, results = _a.results, setTotalRows = _a.setTotalRows;
            // @ts-ignore
            var headers = groups.concat(filteredTotal);
            return (React.createElement(ui_1.DataGridRow, { className: onTop ? theme.sumBar : theme.sumBarBottom, freezeColumnIndex: freezeColumnIndex, columnsWidth: columnsWidth }, headers.map(function (header, index) {
                var headerDisplayValue = header.displayValue ? String(header.displayValue) : null;
                if (index === 0 && (header.isGroup || header.valueDisplay)) {
                    setTotalRows(header, results.length);
                }
                var contextMenuItems = [
                    {
                        label: freezeColumnIndex === index ? "Unfreeze Column" : "Freeze Column",
                        onClick: function () { return setFreezeColumn({
                            target: {
                                checked: freezeColumnIndex !== index,
                                value: index
                            }
                        }); }
                    },
                    { label: "Order " + sortDirection, onClick: function () { return onSort(header.name); } },
                    {
                        label: "Copy",
                        onClick: function () { return lib_1.MemoryClipboard.copy(window.getSelection().toString() || headerDisplayValue || header.name); }
                    },
                    {
                        label: "Set on " + (reportingSumOnTop ? "bottom" : "top"),
                        onClick: _this.onToggleReportingSumOnTop
                    }
                ];
                return (React.createElement(ui_1.DataGridColumn, { key: header.name, density: null },
                    React.createElement(ui_1.ContextMenu, { items: contextMenuItems },
                        React.createElement("div", { className: index <= freezeColumnIndex ? theme.freezeCell : theme.cell }, (onTop && (index > 0 && index < groups.length)) ? "" : header.displayValue || header.name))));
            })));
        };
        _this.resizeColumnsByScreenSize = function (headers) {
            var width = (window.innerWidth - 70) / headers.length;
            var columnsWidth = headers.reduce(function (obj, header, idx) {
                obj[idx] = width;
                return obj;
            }, {});
            _this.onColumnResize(columnsWidth);
        };
        _this.resizeColumnsByEntityFields = function (headers, results) {
            var topLengthSizeByHeader = {};
            results.forEach(function (row) {
                row.fields.forEach(function (field) {
                    var value = field.displayValue || field.value.toString();
                    if (!topLengthSizeByHeader[field.name] || topLengthSizeByHeader[field.name] < value.length) {
                        topLengthSizeByHeader[field.name] = value.length;
                    }
                });
                row.groups.forEach(function (group) {
                    if (!topLengthSizeByHeader[group.name] || topLengthSizeByHeader[group.name] < group.value.length) {
                        topLengthSizeByHeader[group.name] = group.value.length;
                    }
                });
            });
            var columnsWidth = headers.reduce(function (obj, header, idx) {
                obj[idx] = topLengthSizeByHeader[header.name] * 10;
                return obj;
            }, {});
            _this.onColumnResize(columnsWidth);
        };
        _this.renderHeader = function (scrollTop, scrollLeft, columnsWidth, setFreezeColumn, freezeColumnIndex) {
            var _a = _this.props, sortDirection = _a.sortDirection, onSearch = _a.onSearch, sortBy = _a.sortBy, onSort = _a.onSort, searchQueries = _a.searchQueries, reportingSumOnTop = _a.reportingSumOnTop, headers = _a.headers, results = _a.results;
            return (React.createElement(React.Fragment, null,
                React.createElement(ui_1.DataGridRow, { className: theme.header, columnsWidth: columnsWidth }, headers.map(function (header, index) {
                    var props = {
                        blue: true,
                        label: header.name,
                        sortable: true,
                        sortBy: header.name,
                        sortActive: sortBy === header.name,
                        searchKey: header.name,
                        searchable: header.isGroup,
                        searchQuery: searchQueries[header.name || ""],
                        contextMenuItems: [
                            {
                                label: freezeColumnIndex === index ? "Unfreeze Column" : "Freeze Column",
                                onClick: function () { return setFreezeColumn({
                                    target: {
                                        checked: freezeColumnIndex !== index,
                                        value: index
                                    }
                                }); }
                            },
                            { label: "Order " + sortDirection, onClick: function () { return onSort(header.name); } },
                            { label: "Copy", onClick: function () { return lib_1.MemoryClipboard.copy(header.name); } },
                            {
                                label: "Resize columns by screen size",
                                onClick: function () { return _this.resizeColumnsByScreenSize(headers); }
                            },
                            {
                                label: "Resize columns by entity fields",
                                onClick: function () { return _this.resizeColumnsByEntityFields(headers, results); }
                            }
                        ],
                        key: header.name,
                        index: index,
                        freezeColumnIndex: freezeColumnIndex,
                        columnsWidth: columnsWidth,
                        sortDirection: sortDirection,
                        onSort: onSort,
                        onSearch: onSearch,
                    };
                    return (React.createElement(ui_1.DataGridHeaderColumn, tslib_1.__assign({}, props)));
                })),
                reportingSumOnTop && _this.renderSumBar(scrollTop, scrollLeft, columnsWidth, setFreezeColumn, freezeColumnIndex, true)));
        };
        _this.renderRow = function (index, viewportIndex, columnsWidth, freezeColumnIndex, setFreezeColumn) {
            var _a = _this.props, results = _a.results, quickConstraint = _a.quickConstraint, quickFilter = _a.quickFilter, onSort = _a.onSort, onSearch = _a.onSearch, sortDirection = _a.sortDirection;
            return (React.createElement(ReportingRow_1.default, { key: index, item: results[index], columnsWidth: columnsWidth, freezeColumnIndex: freezeColumnIndex, index: index, onQuickFilter: quickFilter, onQuickConstraint: quickConstraint, setFreezeColumn: setFreezeColumn, onSort: onSort, sortDirection: sortDirection, onSearch: onSearch }));
        };
        _this.onColumnResize = function (columnsWidth) {
            _this.props.setColumnsWidth(columnsWidth);
        };
        return _this;
    }
    ReportingList.prototype.render = function () {
        var _a;
        var _b = this.props, results = _b.results, reportingSumOnTop = _b.reportingSumOnTop, fullScreen = _b.fullScreen, getColumnsWidth = _b.getColumnsWidth, headers = _b.headers;
        var columnsWidth = getColumnsWidth();
        var classNames = classnames((_a = {},
            _a[theme.list] = !fullScreen,
            _a[theme.fullScreen] = fullScreen,
            _a));
        return (React.createElement(ui_1.DataGrid, { useStickyScrollbar: true, onColumnResize: this.onColumnResize, className: classNames, extraData: results, headersCount: headers.length, itemsCount: (results || []).length, renderRow: this.renderRow, rowHeight: 40, columnsWidth: columnsWidth, useColumnsWidthState: false, renderFooter: reportingSumOnTop ? null : this.renderSumBar, renderHeader: this.renderHeader }));
    };
    return ReportingList;
}(React.Component));
exports.default = ReportingList;
